import { ParameterType } from '@/study-search/enums';

import { FilterDefinition } from '../FilterDefinition';
import { FilterOptionInformation, SpecialProgrammesFilterOptionValue } from '@studyportals/search-filters';

class BachelorsSpecialProgrammesFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.SPECIAL_PROGRAMMES,
			[
				new FilterOptionInformation(
					'Joint Programmes',
					SpecialProgrammesFilterOptionValue.JOINT_PROGRAMMES,
					'joint-programmes',
					''
				)
			],
			[SpecialProgrammesFilterOptionValue.JOINT_PROGRAMMES]
		);
	}
}

export default new BachelorsSpecialProgrammesFilterDefinition();
